import { Theme } from './types';

export const lightTheme: Theme = {
  colors: {
    bg: {
      primary: 'rgba(255, 255, 255, 1)',
      secondary: 'rgba(249, 249, 249, 1)',
      tertiary: 'rgba(242, 242, 242, 1)',
      overlay: 'rgba(255, 255, 255, 0.8)'
    },
    fg: {
      primary: 'rgba(38, 38, 38, 1)',
      secondary: 'rgba(142, 142, 142, 1)',
      tertiary: 'rgba(199, 199, 199, 1)',
      inverse: 'rgba(255, 255, 255, 1)'
    },
    accent: {
      primary: 'rgba(60, 60, 60, 1)',
      secondary: 'rgba(100, 100, 100, 1)',
      success: 'rgba(88, 195, 34, 1)',
      error: 'rgba(237, 73, 86, 1)',
      warning: 'rgba(255, 164, 26, 1)'
    },
    newng: {
      red: 'rgba(220, 20, 60, 1)',      // Crimson red
      blue: 'rgba(0, 123, 255, 1)',     // Pure vibrant blue (Bootstrap blue)
      white: 'rgba(255, 255, 255, 1)',  // Pure white
      black: 'rgba(0, 0, 0, 1)'         // Pure black
    },
    border: {
      light: 'rgba(219, 219, 219, 1)',
      medium: 'rgba(199, 199, 199, 1)',
      heavy: 'rgba(168, 168, 168, 1)'
    },
    gradients: {
      primary: 'linear-gradient(45deg, rgba(60, 60, 60, 1), rgba(100, 100, 100, 1))',
      surface: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%)',
      accent: 'linear-gradient(135deg, rgba(80, 80, 80, 1), rgba(100, 100, 100, 1), rgba(120, 120, 120, 1))'
    },
    overlay: {
      light: 'rgba(0, 0, 0, 0.1)',
      medium: 'rgba(0, 0, 0, 0.2)',
      heavy: 'rgba(0, 0, 0, 0.4)'
    }
  },
  buttons: {
    primary: {
      background: 'rgba(60, 60, 60, 1)',
      text: 'rgba(255, 255, 255, 1)',
      hover: 'rgba(80, 80, 80, 1)',
      active: 'rgba(40, 40, 40, 1)'
    },
    secondary: {
      background: 'rgba(255, 255, 255, 1)',
      text: 'rgba(0, 0, 0, 1)',
      hover: 'rgba(245, 245, 245, 1)',
      active: 'rgba(235, 235, 235, 1)'
    },
    error: {
      background: 'rgba(237, 73, 86, 1)',
      text: 'rgba(255, 255, 255, 1)',
      hover: 'rgba(220, 45, 60, 1)',
      active: 'rgba(201, 28, 45, 1)'
    },
    disabled: {
      opacity: 0.3
    },
    borderRadius: '8px',
    transition: 'all 0.2s ease-in-out'
  },
  effects: {
    frostedGlass: {
      background: 'rgba(255, 255, 255, 0.8)',
      blur: '10px',
      border: '1px solid rgba(0, 0, 0, 0.1)'
    },
    gradient: {
      primary: 'linear-gradient(45deg, rgba(60, 60, 60, 1), rgba(100, 100, 100, 1))',
      dark: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%)',
      evolved: 'linear-gradient(135deg, rgba(80, 80, 80, 1) 0%, rgba(100, 100, 100, 1) 50%, rgba(120, 120, 120, 1) 100%)'
    },
    shadow: {
      sm: '0 1px 3px rgba(0, 0, 0, 0.3)',
      md: '0 4px 6px rgba(0, 0, 0, 0.4)',
      lg: '0 10px 15px rgba(0, 0, 0, 0.5)'
    }
  }
};
